import {
  App,
  Button,
  Card,
  Dropdown,
  Input,
  Popconfirm,
  Popover,
  Segmented,
  Space,
  Table,
  Tag,
  Tooltip,
  Tree,
} from 'antd';
import { MdDelete, MdEdit, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import { useNavigate } from 'react-router-dom';
import { useRef, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  deleteAccount,
  getAccounts,
  getAccountsBalances,
  getAccountsTree,
} from '../../network/ChartAccount';
import {
  PlusOutlined,
  SearchOutlined,
  DownOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { colorPrimary } from '../../utils/utils';
import StatusTag from '../../hooks/StatusHook';
import { useSelector } from 'react-redux';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';

const ChartAccountTable = ({ t }) => {
  const searchInput = useRef(null);
  const [searchTextValue, setSearchTextValue] = useState('');
  const { currentLang } = useSelector((state) => state.user);
  const [searchText, setSearchText] = useState('');
  console.log(searchText, 'searchText');

  const [nameSearch, setNameSearch] = useState('');
  const [dataBalances, setDataBalances] = useState([]);
  const [accountType, setAccountType] = useState(2);
  const [textValue, setTextValue] = useState('');

  const [pageCount, setPageCount] = useState(1);
  const client = useQueryClient();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const searchInputMobile = useRef(null);

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm, setSelectedKeys) => {
    confirm();
    setSearchText('');
    setSearchTextValue('');
    if (clearFilters) {
      clearFilters();
    }
    if (setSelectedKeys) {
      setSelectedKeys(['']);
    }
  };
  const { data, isLoading } = useQuery({
    queryKey: [
      queryKeys.getAccounts,
      searchText,
      nameSearch,
      currentLang,
      pageCount,
    ],
    queryFn: () => getAccounts(pageCount, searchText, nameSearch, currentLang),
    keepPreviousData: true,
  });
  const { data: accountsTree, isLoading: loading } = useQuery({
    queryKey: [queryKeys.getAccountsTree],
    queryFn: () => getAccountsTree(),
    keepPreviousData: true,
  });
  const {
    mutate: accountBalance,
    isLoading: loadingBalance,
    data: accountsBalances,
  } = useMutation({
    mutationFn: (data) => getAccountsBalances(data),
    onSuccess: (data) => {
      console.log(data, 'data');
      setDataBalances([...dataBalances, ...data?.message]);
    },
    onError: () => {
      message.error('Something went wrong!');
    },
  });
  console.log(accountsBalances, 'accountsBalances');
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteAccount(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({
          queryKey: [queryKeys.getAccounts],
        });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const columns = [
    {
      title: t.AccountName,
      dataIndex: 'account_name',
      // filteredValue: [searchText],
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={t.fileNumber}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() =>
              handleSearch(selectedKeys, confirm, 'account_name')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleSearch(selectedKeys, confirm, 'account_name')
              }
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText('');
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/accounts/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.AccountType,
      dataIndex: 'account_type',
    },
    {
      title: t.AccountCurrency,
      dataIndex: 'account_currency',
    },
    {
      title: t.reportType,
      dataIndex: 'report_type',
    },
    {
      title: t.RootType,
      dataIndex: 'root_type',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={t.RootType}
            value={searchTextValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setSearchTextValue(e.target.value);
              // setSearchText(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm)}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              // onClick={() => confirm()}
              onClick={() => handleSearch(selectedKeys, confirm)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() =>
                clearFilters &&
                handleReset(clearFilters, confirm, setSelectedKeys)
              }
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setSearchText('');
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.Total,
      dataIndex: 'total',
    },
    // {
    //   title: t.status,
    //   dataIndex: 'status',
    //   render: (status) => <StatusTag status={status} />,
    // },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          // <Space>
          //   <Popover
          //     placement="top"
          //     title={t.edit}
          //     // onClick={() => navigate(`/accounts/${record.custom_file_number}`)}
          //     onClick={() => navigate(`/accounts/${record.name}`)}
          //   >
          //     <Button size="small" type="primary">
          //       <MdModeEditOutline />
          //     </Button>
          //   </Popover>
          //   <Popconfirm
          //     title={t.deleteAccount}
          //     description={t.areYouSure}
          //     onConfirm={() => handleRemove.mutate(record.name)}
          //     // onCancel={cancel}
          //     okText={t.yes}
          //     cancelText={t.no}
          //   >
          //     <Button size="small" type="primary" danger>
          //       <MdDelete />
          //     </Button>
          //   </Popconfirm>
          // </Space>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'edit',
                  label: (
                    <span className="flex items-center gap-2 text-[#818181] font-[700] text-[14px]">
                      <EditOutlined />
                      {t.edit} {t.account}
                    </span>
                  ),
                  onClick: () => navigate(`/accounts/${record.name}`),
                },
                {
                  key: 'delete',
                  danger: true,
                  label: (
                    <Popconfirm
                      // placement="left"
                      title={t.delete}
                      description={t.areYouSure}
                      onConfirm={() => handleRemove.mutate(record?.name)}
                      okText={t.yes}
                      cancelText={t.no}
                      okType="danger"
                    >
                      <span className="flex items-center gap-2  font-[700] text-[14px]">
                        <DeleteOutlined />
                        {t.delete} {t.account}
                      </span>
                    </Popconfirm>
                  ),
                },
              ],
            }}
            // placement="bottomRight"
            overlayClassName="custom-dropdown"
            trigger={['click']}
          >
            <Button
              type="text"
              icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
            />
          </Dropdown>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  // const dataTable = data?.message?.accounts?.map((item, index) => {
  //   return {
  //     ...item,
  //     key: index,
  //   };
  // });
  // const transformLabelToTitle = (data = []) => {
  //   const dataBalancesArray = dataBalances?.map((item) => item?.value) || [];
  //   const dataBalancesArrayBalance = dataBalances?.map((item) => item?.balance) || [];
  //   return data?.map((item) => {
  //     const { label, children, ...rest } = item;
  //     const transformedItem = {
  //       title: dataBalancesArray === item?.value ? `${label}(${dataBalancesArrayBalance})` : label,
  //       ...rest,
  //     };
  //     if (Array.isArray(children) && children.length > 0) {
  //       transformedItem.children = transformLabelToTitle(children);
  //     }
  //     return transformedItem;
  //   });
  // };
  const transformLabelToTitle = (data = []) => {
    const dataBalancesMap = new Map();
    dataBalances?.forEach((item) => {
      dataBalancesMap.set(item?.value, item?.balance);
    });

    return data?.map((item) => {
      const { label, children, ...rest } = item;
      const balance = dataBalancesMap.get(item?.value);
      // console.log('balance:', balance);
      const transformedItem = {
        title: balance
          ? `${label} (${balance})`
          : `${label} ${balance === 0 ? `(0)` : ''}`,
        ...rest,
      };
      if (Array.isArray(children) && children.length > 0) {
        transformedItem.children = transformLabelToTitle(children);
      }
      return transformedItem;
    });
  };
  const handleEditClick = (node) => {
    // console.log('Edit clicked for:', node);
    navigate(`/accounts/${node?.value}`);
  };
  const handlePageChange = (pageNumber) => {
    setPageCount(pageNumber?.current);
  };

  return (
    <div className="chart-table">
      {/* <Heading title={t.Finance} subTitle={t.ChartAccount} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Space
          style={{
            width: '100%',
            marginBottom: 16,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          wrap
        >
          <Segmented
            defaultValue={2}
            options={[
              {
                label: t.List,
                value: 2,
              },
              {
                label: t.Tree,
                value: 1,
              },
            ]}
            onChange={(value) => {
              setAccountType(value);
            }}
          />
          <Button type="primary" onClick={() => navigate('/accounts/add')}>
            <PlusOutlined size={10} /> {t.AddAccount}
          </Button>
        </Space>
        {accountType === 1 ? (
          <Tree
            showLine
            switcherIcon={<DownOutlined />}
            className="tree-container-account"
            onExpand={(expandedKeys, { expanded, node }) => {
              // console.log(expandedKeys);
              console.log(expanded, 'expanded');
              console.log(node, 'node');
              if (expanded) {
                const keys = node?.children?.map((x) => `"${x?.value}"`);
                console.log(keys, 'keys');
                accountBalance(keys);
              }
            }}
            onLoadedData={(treeNode) => {
              console.log(treeNode);
            }}
            // onMouseEnter={(treeNode) => {
            //   console.log(treeNode);
            // }}
            titleRender={(node) => (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <span>{node.title}</span>
                {/* <Tooltip title="Edit"> */}
                <Button
                  type="text"
                  size="small"
                  icon={
                    <EditOutlined
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditClick(node);
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  }
                />
                {/* </Tooltip> */}
              </div>
            )}
            treeData={transformLabelToTitle(accountsTree?.message)}
            // style={{ zoom: 1.5 }}
          />
        ) : (
          <Table
            className="table_custom"
            columns={columns}
            dataSource={dataTable}
            loading={isLoading}
            // searchInput={true}
            scroll={{ x: 'max-content' }}
            // pagination={{
            //   responsive: true,
            //   current: pageCount || 1,
            //   total: data?.message?.total_count || 0,
            //   pageSize: 10,
            //   showSizeChanger: false,
            //   defaultPageSize: 10,
            // }}
            pagination={{
              responsive: true,
              current: pageCount || 1,
              total: data?.message?.total_count || 0,
              pageSize: 10,
              showSizeChanger: false,
              defaultPageSize: 10,
              hideOnSinglePage: true,
              // align: 'center',
              itemRender: (current, type, originalElement) => {
                if (type === 'prev') {
                  return (
                    <div
                      // onClick={handlePrevClick}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        order: 1,
                      }}
                    >
                      <IoIosArrowRoundForward
                        size={16}
                        style={{
                          transform:
                            currentLang === 'en'
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                        }}
                      />
                      <span>{t.prev}</span>
                    </div>
                  );
                }
                if (type === 'next') {
                  return (
                    <div
                      // onClick={handleNextClick}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        order: -1,
                      }}
                    >
                      <span> {t.next}</span>
                      <IoIosArrowRoundBack
                        size={16}
                        style={{
                          transform:
                            currentLang === 'en'
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                        }}
                      />
                    </div>
                  );
                }
                return originalElement;
              },
              // onChange: (page) => {
              //   setFilterData({ ...filterData, page });
              // },
            }}
            onChange={handlePageChange}
          />
        )}
      </Card>
    </div>
  );
};

export default ChartAccountTable;
